import { DataCollectionMetadata, DataInput } from "../models/DataCollectionPaneConfig";
import { settings } from "../../../../settings/settings-util";
import { VTree } from "virtual-dom";
import h from "virtual-dom/h";


export const buildErrorMessages = (input: DataInput, passedSettings: typeof settings): VTree[] => {
    const className = passedSettings.classNames.dataCollectionPaneError;
    const errorValidationText = input.validationtext ?? passedSettings.textConstants.dataCollectionFormatError;
    const errorRequiredText = input.requiredtext ?? passedSettings.textConstants.dataCollectionRequiredError;

    const formatError = h('div', { className, attributes: { 'data-error-type': 'format' } }, errorValidationText);
    const requiredError = h('div', { className, attributes: { 'data-error-type': 'required' } }, errorRequiredText);

    return [formatError, requiredError];
};

export const buildCustomValidationsErrorElement = (metadata: DataCollectionMetadata, passedSettings: typeof settings) => {
    const className = passedSettings.classNames.dataCollectionPaneError;
    const errorValidationText = metadata.customValidationText!;
    const formatError = h('div', { className, attributes: { 'data-error-type': 'custom' } }, errorValidationText);
    return formatError;
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/elements/ErrorMessages.ts